
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/emporium/star/list",
      function () {
        return require("private-next-pages/emporium/star/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/emporium/star/list"])
      });
    }
  